import { Component, OnInit } from '@angular/core';

import { AbstractPropertyEditorBase } from '../../types/property-editor.types';

@Component({
  selector: 'df-multi-text-box-property-editor',
  templateUrl: './multi-text-box-property-editor.component.html',
  styleUrls: ['./multi-text-box-property-editor.component.css']
})
export class MultiTextBoxPropertyEditorComponent extends AbstractPropertyEditorBase implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {}

  afterControlValueInit() {
    if (this.settings) {
      if (this.settings.maxlength === undefined) {
        this.settings.maxlength = 500;
      }
    }
  }
}
